export default "__VITE_ASSET__d50823c0__"